import React from 'react';
import s from './styles.module.scss';
import classNames from 'classnames';

interface IBaseButton {
  className?: string;
  onClick?: () => void;
}

export interface IControlButtonProps extends IBaseButton {
  active?: boolean;
  text?: string;
  disabled?: boolean;
}

export interface IBaseControlButtonProps extends IBaseButton {
  icon?: React.ReactNode;
  text?: string;
  disabled?: boolean;
}

const BaseControlButton: React.FC<IBaseControlButtonProps> = (props) => {
  const {
    icon,
    text,
    disabled = false,
    className = '',
    onClick = () => {},
  } = props;

  const btnClassNames = classNames(s['btn'], className);

  return (
    <button
      disabled={disabled}
      className={btnClassNames}
      onClick={(e) => {
        e.currentTarget.blur();
        onClick();
      }}
    >
      {icon && <i>{icon}</i>}
      {text && <span>{text}</span>}
    </button>
  );
};

export default BaseControlButton;
